export default __webpack_public_path__ + "media/buildings/NewDev_AdUnit@2x-eec14478.png";